import React from 'react'
import {connect} from 'react-redux'
import AccordionPage from './AccordionPage'
import {TweenMax,TimelineMax,TweenLite, Power2, Power0} from 'gsap'
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';

class PageAccordion extends React.Component {



  constructor(){
    super()

    this.state = {
        disableRotationAnimation:false,
        lastHeight:-1,
        holdSection:false
    }

    this.setDisableAnimations = this.setDisableAnimations.bind(this)
    this.lookForAnchor = this.lookForAnchor.bind(this);
    this.requestAnimFrame = this.requestAnimFrame.bind(this)
    this.checkForContentUpdate = this.checkForContentUpdate.bind(this)
    this.rePositionScroll = this.rePositionScroll.bind(this)
    this.scrollToSection = this.scrollToSection.bind(this)

    this.beginTransition = this.beginTransition.bind(this)
    this.endTransition = this.endTransition.bind(this)

    this.holdActiveSectionAtTop = this.holdActiveSectionAtTop.bind(this)

  }
  requestAnimFrame(cb){
    let  anim = window.requestAnimationFrame       ||
                  window.webkitRequestAnimationFrame ||
                  window.mozRequestAnimationFrame    ||
                  function( callback ){
                    window.setTimeout(callback, 1000 / 60);
                  };
        //(this._ismounted === true)?
          anim(cb)
        //: console.log("component not mounted, requestAnimFrame will not call");
    }


  checkForContentUpdate(){

    //console.log(this.refs.container.offsetHeight)

    if(this.state.lastHeight!==this.refs.container.offsetHeight){
      let pages = this.refs.container.querySelectorAll('.accordion-page')
      let yPosition = 0;

      for(let i=0;i < pages.length; i++){

            pages[i].style.top = yPosition+'px';

            if(pages[i].querySelector('.accordion-link.active')){
              //console.log(pages[i].offsetHeight);
                yPosition += Math.round(pages[i].offsetHeight);
            }else{
              yPosition += Math.round(window.innerWidth*0.33);
            }


      }
      //yPosition += window.innerWidth*0.33;
      this.refs.container.style.height = yPosition+'px'

      this.setState({lastHeight:this.refs.container.offsetHeight})
    }

    this.requestAnimFrame(this.checkForContentUpdate)
  }


  setDisableAnimations(disable_boo){
    this.setState({disableRotationAnimation:disable_boo})
  }



  componentDidMount(){

    //console.log("Do we have a slug?",window.location.pathname);

    this.lookForAnchor();
    //this.requestAnimFrame(this.checkForContentUpdate)

    //setTimeout(this.lookForAnchor,500);

  }

  lookForAnchor(){
    // find the right place to scrollto based on scroll-anchor and pageslug
    //console.log("Loook for slug");
    if(window.location.pathname !== '/'){
      let currentSlug = window.location.pathname.toLowerCase();

      let foundMatch = false


      // look for the whole slug

      let slugPos = this.searchForAnchorPosition(currentSlug)

      //console.log("slugPos",slugPos);
      if(slugPos !==-1){
            window.scrollTo(0,slugPos)
      }


      // look for the first part if not found eg. /work/ instead of /work/bla-bla

      if(slugPos ==-1){

          let partSlug = '/'+currentSlug.split('/')[1]
          //console.log('partSlug',partSlug);
          slugPos = this.searchForAnchorPosition(partSlug)
          if(slugPos !==-1){
                window.scrollTo(0,slugPos)
          }
      }

    }

  }

  searchForAnchorPosition(currentSlug){

    let anchors = document.querySelectorAll('.scroll-anchor')
    let anchorPos = -1;

    for(let i=0; i < anchors.length;i++){

        let anchor = anchors[i]
        if(anchor.getAttribute('pageslug')){
        let anchorSlug = anchor.getAttribute('pageslug').toLowerCase();


        //Remove trailing /
        anchorSlug = anchorSlug.replace(/\/$/, '');
        currentSlug = currentSlug.replace(/\/$/, '');


        if(anchorSlug === currentSlug){
          //console.log("We have a match",anchorSlug,anchor.getBoundingClientRect().top);

          //window.scrollTo(0,anchor.getBoundingClientRect().top)

          anchorPos = anchor.getBoundingClientRect().top+window.scrollY;
          return anchorPos

        }}
        //console.log(anchor.getAttribute('pageslug'));

    }

    return anchorPos


  }

  rePositionScroll(){
      let activeSlug = this.refs.container.querySelector('.accordion-page.active').getAttribute('pageslug')
       ///console.log('active section',this.refs.container.querySelector('.accordion-page.active').getAttribute('pageslug'));

       //console.log(this.searchForAnchorPosition(activeSlug));

       //TweenMax.set(window,{scrollTo:this.searchForAnchorPosition(activeSlug)});
  }

  scrollToSection(){
    let activeSlug = this.refs.container.querySelector('.accordion-page.active').getAttribute('pageslug')
     //console.log('scroll to active section',this.refs.container.querySelector('.accordion-page.active').getAttribute('pageslug'));

     console.log(this.searchForAnchorPosition(activeSlug));
     //debugger
     TweenMax.to(window,.5,{scrollTo:this.searchForAnchorPosition(activeSlug)});

  }

  beginTransition(){
      //console.log("Begin Transitions");
      /// Hold at top
      //this.holdActiveSectionAtTop();
      //this.setState({holdSection:true})
  }

  holdActiveSectionAtTop(){
    let activeSlug = this.refs.container.querySelector('.accordion-page.active').getAttribute('pageslug')
    let position = this.searchForAnchorPosition(activeSlug)


      let pages = this.refs.container.querySelectorAll('.accordion-page')
      let yPosition = 0;
      let positionOnPage = 0;

      for(let i=0;i < pages.length; i++){

            if(pages[i].querySelector('.accordion-link.active')){
              //console.log(pages[i].offsetHeight);
               positionOnPage = yPosition

            }else{
              yPosition += Math.round(pages[i].offsetHeight);
              //yPosition += Math.round(window.innerWidth*0.33);
            }


      }
    //console.log(positionOnPage);
    TweenMax.set(this.refs.container,{top:-positionOnPage});

    if(this.state.holdSection){
      this.requestAnimFrame(this.holdActiveSectionAtTop)
    }else{
      TweenMax.set(this.refs.container,{top:'auto'});
      TweenMax.set(window,{scrollTo:this.searchForAnchorPosition(activeSlug)});
    }

  }


  endTransition(){
    //console.log("End Transitions");
      /// Release hold at top
    //this.setState({holdSection:false})
  }



  render() {

      //console.log("PageAccordion",this);

      return(<div id="pageAccordion" ref="container">

            {
              this.props.optionsData.data.menu_items.map((item,i)=>{
                  return <AccordionPage pageNumber={i} beginTransition={this.beginTransition} endTransition={this.endTransition}  setDisableAnimations={this.setDisableAnimations} disableRotationAnimations={this.state.disableRotationAnimation} key={'p'+i} {...item} />
              })
            }

      </div>)
  }
}

const mapStateToProps = (state)=>{
    let pagesData = state.KastnerStore.pagesData, optionsData = state.KastnerStore.optionsData

    return{
      pagesData,
      optionsData
    }
}

export default connect(mapStateToProps)(PageAccordion);



// WEBPACK FOOTER //
// ./src/modules/pageAccordion/PageAccordion.js